const URL = 'properties-clicked-resume'

export default ({ apiClient }) => ({
  list(params) {
    return apiClient.get(URL, {}, params)
  },
  show(uuid) {
    return apiClient.get(`${URL}/${uuid}`, {}, {})
  },
})
